import PrintTemplate from 'react-print'
import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import {formatPrice} from '../helpers/helpers'

import QMainProductViewPrint from './QMainProductViewPrint'
import QBendedViewPrint from './QBendedViewPrint'
import QHardwareViewPrint from './QHardwareViewPrint'
import QMiscellaneousViewPrint from './QMiscellaneousViewPrint'

class QuotationPrint extends Component{
    render() {
        return (
            <PrintTemplate>
            	<div className="mainWrapper">
	            	<div className="forDateAndNumber">
		            	<div className="qNumber">
		            		<span>{this.props.quotation.quoteNumber}</span>
		            	</div>
		            	<div className="quoteDate">
		            		<span>{this.props.quotation.quoteDate}</span>
		            	</div>
	            	</div>
	            	<div className="wrapperHolder">
		                <div className="wrapperPrint">
		                	<div className="leftHolder">
		                		<span className="forCustomerNamePrint">{this.props.customer.name}</span>
		                	</div>
		                	<div className="rightHolder">
								<span>{this.props.customer.number}</span>
		                	</div>
		                </div>
		                <div className="clearfix"></div>

		                <div className="wrapperPrint">
		                	<div className="leftHolder">
		                		 <span>{this.props.customer.project}</span>
		                	</div>
		                	<div className="rightHolder">
								<span>{this.props.customer.reference}</span>
		                	</div>
		                </div>
		                <div className="clearfix"></div>

		                <div className="wrapperPrint">
		                	<div className="leftHolder">
		                		 <span>{this.props.customer.location}</span>
		                	</div>
		                	<div className="rightHolder">
							 	<span>{this.props.customer.representative}</span>
		                	</div>
		                </div>
	                </div>
	                <div className="clearfix"></div>
	                <div className="marginTop70px">
	                	<table className="table tablePrint">
	                		<thead>
	                			<tr>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                			</tr>
	                		</thead>
	                		<tbody>
					            {
					            	this.props.products &&                                     
					                    Object.keys(this.props.products).map(function (key){
					                        let list = this.props.products[key]
					                        
					                        if(list.category ==="Main Product"){                                                   
	                                                    //console.log(list)
	                                                    return <QMainProductViewPrint key={key} product={list}/>                                                  
	                                                   }

	                                        if(list.category ==="Bended Accessories"){                                                   
	                                            //console.log(list)
	                                            return <QBendedViewPrint key={key} product={list}/>                                                  
	                                           }                                                   
					                           
					                    }.bind(this))
					            }
					            <tr>                                    
	                                <td className="pName"></td>
	                                <td className="pDimension"></td>
	                                <td className="pQtyPUnit"></td>
	                                <td className="unitAlone"></td>
	                                <td className="pPricePunit"></td>
	                                <td className="priceUnitAlone"></td>
	                                <td className="pDisc fontWeightBold">Subtotal</td>                                    
	                                <td className="pAmount fontWeightBold">{formatPrice(this.props.quotation.totalValue) && formatPrice(this.props.quotation.totalValue)}</td>
	                            </tr>
					            
					        </tbody>
					    </table>
					    <table className="table tablePrint">
	                		<thead>
	                			<tr>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                			</tr>
	                		</thead>
	                		<tbody>
					            {
					            	this.props.products &&                                     
	                                            Object.keys(this.props.products).map(function (key){
	                                                let list = this.props.products[key]
	                                                
	                                                if(list.category ==="Hardware Accessories"){                                                   
	                                                    //console.log(list)
	                                                    return <QHardwareViewPrint key={key} product={list}/>                                                  
	                                                   }

	                                                if(list.category ==="Miscellaneous"){                                                   
	                                                    //console.log(list)
	                                                    return <QMiscellaneousViewPrint key={key} product={list}/>                                                  
	                                                   }
	                                                                                        
	                                                   
	                                            }.bind(this))

					            }
					            <tr className="printArea">                                    
	                                <td className="pName"></td>
	                                <td className="pDimension"></td>
	                                <td className="pQtyPUnit"></td>
	                                <td className="unitAlone"></td>
	                                <td className="pPricePunit"></td>
	                                <td className="priceUnitAlone"></td>
	                                <td className="pDisc fontWeightBold">Subtotal</td>                                    
	                                <td className="pAmount fontWeightBold">{formatPrice(this.props.quotation.totalValue2) && formatPrice(this.props.quotation.totalValue2)}</td>
	                            </tr>
					            
					        </tbody>
					    </table>
	                </div>


				    <div className="totalHolder">
					    <table className="table tablePrint">
					    	<thead>
					    		<tr>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                				<th></th>
	                			</tr>
					    	</thead>
					    	<tbody>				    		
		                        <tr>
		                            <td className="fontSize12" colSpan={4}>Total Materials</td>
		                            <td className="fontSize12" colSpan={2}></td>
		                            <td className="pAmount2 fontWeightBold" colSpan={2}>{formatPrice(this.props.quotation.totalMaterials) && formatPrice(this.props.quotation.totalMaterials)}</td>
		                        </tr>
		                        <tr>
		                            
		                            <td className="fontSize12" colSpan={4}>Delivery Cost</td>
		                            <td className="fontSize12" colSpan={2}></td>
		                            <td className="pAmount2 fontWeightBold" colSpan={2}>{formatPrice(this.props.quotation.deliveryCharge) && formatPrice(this.props.quotation.deliveryCharge)}</td>
		                        </tr>
		                        <tr>
		                            
		                            <td className="fontWeightBold tot" colSpan={4}>Total Quotation</td>
		                            <td className="fontSize12 borderNoLR" colSpan={2}></td>
		                            <td className="pAmount2tot fontWeightBold" colSpan={2}>{formatPrice(this.props.quotation.totalQuote) && formatPrice(this.props.quotation.totalQuote)}</td>
		                        </tr>
					    	</tbody>
					    </table>
						<div className="termsDelivery">
						    <div className="terms">
						    	<span>50% down payment upon placement of order</span><br/>
						    	<span>50% full payment upon notice of delivery</span>
						    </div>
						    <div className="sched">
						    	<br/><br/><br/>
						    	<span className="text-uppercase">{this.props.customer.sched}</span>
						    	<br/>
						    	<span className="text-uppercase">{this.props.customer.eta}</span>				    	
						    </div>
						</div>
					    <div className="consignee">
						    <div className="salesRep">
						    	<span>{this.props.customer.representative}</span>
						    </div>
						    <div className="areaManager">
						    	<span>JANE SOLINAP</span>
						    </div>
				    	</div>
				    </div>
				    <div class="clearfix"></div>
				</div>
			    
            </PrintTemplate>
        );
    }
};

export default QuotationPrint;


// WEBPACK FOOTER //
// ./src/components/QuotationPrint.js